import { IntegratorTotalEarningsResponse } from '@/DTOs/integrators';

export const mockIntegratorTotalEarnings: IntegratorTotalEarningsResponse = {
  totalEarnings: 850.0,
  unpaidBalance: 32.0,
};
